import * as React from "react";
const SvgTab = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.872 13.872v9.187h20.256V10.941H20.621v10.62H3.379V9.936h10.795V8.438H3.38V6.192h10.68V4.685H1.872v9.187ZM15 7v2.936H22.13V4.685H15V7Z", fill: "currentColor" })));
export default SvgTab;
